import React from "react";
import { createRoot } from 'react-dom/client';
import ErrorBox from "../../common/ErrorBox";
import TableComponent from "./TableComponent";
import { useState, useEffect } from "react";
import { ConfigProvider, Modal, App, Spin } from 'antd';
import { EditableContextProvider } from "../../common/EditableContextProvider";
import FormComponent from "./FormComponent";
import { customTheme } from "../../common/customTheme";
import { useClientes } from "./useClientes";
import { Formik, Form } from "formik";
import * as Yup from 'yup';

export default function Main() {
    const context = useClientes();

    useEffect(() => {
        Promise.all([context.items.fillItems()]);
    }, []);

    return (
        <div>
            <EditableContextProvider data={{
                ...context
            }}
            >
                <div className='my-1 py-1 d-flex justify-content-between'>
                    <button className="btn btn-sm agregarBgColor"
                        onClick={() => { context.items.newItem(); }}
                    >
                        <i className="fa-solid fa-plus me-1"></i>
                        Agregar
                    </button>

                    <button className="btn btn-sm agregarBgColor"
                        onClick={() => { context.fileModalParams.showModalFile(); }}
                    >
                        <i className="fa-solid fa-table me-1"></i>
                        Subir datos de cliente (Excel)
                    </button>
                </div>
                <TableComponent />

                <Modal title="Formulario"

                    open={context.formParams.formVisibility}
                    onCancel={context.formParams.hideForm}
                    destroyOnClose={true}
                    footer={null}
                >
                    <FormComponent />
                </Modal>

                <Modal title="Formulario"
                    open={context.fileModalParams.modalFileVisibility}
                    onCancel={context.fileModalParams.hideModalFile}
                    destroyOnClose={true}
                    footer={null}
                >
                    <Formik
                        initialValues={{ massive_file: null }}
                        onSubmit={context.fileModalParams.submitUploadFile}
                        enableReinitialize={true}
                    >
                        {
                            (formik) => (
                                <Form action="">
                                    <div className="mb-2">
                                        <label className="form-label" htmlFor="massive_file">
                                            Archivo:
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <input type="file" className="form-control form-control-sm" name="massive_file" id="massive_file"
                                            onChange={(e) => context.fileModalParams.setFileParam(e.target.files[0])}
                                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                            required />
                                    </div>
                                    <div className="mb-2 d-flex justify-content-between">
                                        <div>
                                            <span className="text-danger">(*) </span>
                                            <u>Campo obligatorio.</u>
                                        </div>
                                        <button type="submit" className="btn btn-sm btn-light border border-secondary px-4">
                                            {
                                                (context.fileModalParams.fileLoading) ? (
                                                    <Spin size="small" />
                                                ) : "Guardar"
                                            }
                                        </button>
                                    </div>
                                </Form>
                            )
                        }
                    </Formik>
                </Modal>

            </EditableContextProvider>
        </div>
    );
}

let main = document.getElementById('clientes-main');
if (main) {
    const root = createRoot(main);
    root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App>
                        <Main />
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}
